/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getDashboardRequestSchema = z.object({
  timezone: z.string().min(1).max(64).optional(),
});

export type IGetDashboardRequest = z.infer<typeof getDashboardRequestSchema>;
